<template>
    <DTag
        v-if="noLink"
        :color="activeIncident ? 'danger' : 'secondary'"
        label="Incident"
        icon="flag-variant-outline"
    />
    <Link
        v-else
        :href="incidentLink"
    >
        <DTag
            :color="activeIncident ? 'danger' : 'secondary'"
            label="Incident"
            icon="flag-variant-outline"
        />
    </Link>
</template>

<script setup>
import { route } from '~@/Composables/route'
import { computed } from 'vue'

const props = defineProps({
    activeIncident: {
        type: Boolean,
        default: false
    },
    customerId: {
        type: Number,
        default: null
    },
    relationType: {
        type: String,
        default: null
    },
    relationId: {
        type: Number,
        default: null
    },
    noLink: {
        type: Boolean,
        default: false
    }
})

const incidentLink = computed(() => route('customers.customers.business-incidents.index', { customer: props.customerId, _query: { relation_type: props.relationType, relation_id: props.relationId, status: 'open' } }))
</script>
